import React from 'react';
import SizeTable from '../SizeTable/';
import PropTypes from 'prop-types';

const ProductMeasurements = ({
    features,
    sizeMeasurementData,
    sizeGuide,
    measurementType,
    toggleUnits,
    changeSelectedSku,
    onSelectSku,
    masterCategory,
    skus,
    selectedSku = null,
    setMeasurements = () => {},
    setMeasuringGuide = () => {},
    hmamContent,
    loadingHMAM = false,
    bem,
}) => {
    return (
        <div>
            <SizeTable
                features={features}
                sizeData={sizeMeasurementData}
                title={sizeGuide.sizeMeasurementsTitle}
                details={sizeGuide.sizeMeasurementsDetails}
                slideToScroll={sizeGuide.slideToScroll}
                sizeWrapperClass={bem('sizeMeasurementWrapper', measurementType)}
                toggle={true}
                onToggleUnits={toggleUnits}
                onSelectSku={changeSelectedSku ? onSelectSku : null}
                textLeft={sizeGuide.cm}
                textRight={sizeGuide.in}
                masterCategory={masterCategory}
                skus={skus}
                selectedSku={selectedSku}
                setMeasuringGuide={setMeasuringGuide}
                setMeasurements={setMeasurements}
                coreMediaHMAM={hmamContent}
                loadingHMAM={loadingHMAM}
            />
            {sizeMeasurementData && sizeGuide.compareSize && (
                <div className={bem('compareSize')}>
                    <p className={bem('details')}>{sizeGuide.compareSize.text()}</p>
                    {sizeGuide.compareSize.subText()}
                </div>
            )}
        </div>
    );
};

const baseProps = {
    features: PropTypes.object,
    sizeMeasurementData: PropTypes.array(),
    sizeGuide: PropTypes.object,
    measurementType: PropTypes.string,
    toggleUnits: PropTypes.func,
    changeSelectedSku: PropTypes.func,
    onSelectSku: PropTypes.func,
    masterCategory: PropTypes.array,
    skus: PropTypes.array,
    selectedSku: PropTypes.string,
    setMeasuringGuide: PropTypes.func,
    setMeasurements: PropTypes.func,
    hmamContent: PropTypes.func,
    loadingHMAM: PropTypes.bool,
    bem: PropTypes.func,
};

ProductMeasurements.propTypes = baseProps;

export default ProductMeasurements;
